import axios from '../../axios';

export default {
  namespaced: true,

  state: {
  },

  getters: {
  },
  mutations: {
  },

  actions: {
    fetchAllTransport({
      state, commit, dispatch, getters, rootGetters,
    }, bookingId) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/transportation/bookingid/${bookingId}`).then((res) => {
          resolve(res);
        });
      });
    },
    addTransport({
      state, commit, dispatch, getters, rootGetters,
    }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/core/transportation', data).then((res) => resolve(res)).catch((error) => reject(error));
      });
    },
    deleteTransport({
      state, commit, dispatch, getters, rootGetters,
    }, bookingId) {
      return new Promise((resolve, reject) => {
        axios.delete(`/core/transportation/${bookingId}`).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
